import { useState } from 'react'

const THEMES = ['light', 'dark']
const DEFAULT_THEME = 'light'

export default function useTheme(theme) {
	const [currentTheme, setCurrentTheme] = useState(THEMES.indexOf(theme) > -1 ? theme : DEFAULT_THEME)

	const handleChangeCurrentTheme = (newTheme) => {
		if (THEMES.indexOf(newTheme) > -1) {
			setCurrentTheme(newTheme)
		}
	}

	return {
		theme: currentTheme,
		setTheme: handleChangeCurrentTheme
	}
}
